import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { PATH_HOME_PAGES, PATHS_PROFILE_PAGES, PATHS_USER_PAGES } from './commons/config/path-pages';
import { LoginComponent } from './login/login.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { MembershipComponent } from './membership/membership.component';

const routes: Routes = [
  {
    path: 'membership',
    component: MembershipComponent
  },
  {
    path: '',
    redirectTo: 'login',  
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'changePassword',
    component: ChangePasswordComponent
  },
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: PATH_HOME_PAGES.homePage.onlyPath,
        loadChildren: () => import('./home/home.module').then((m) => m.homeModule)
      },
      {
        path: PATHS_USER_PAGES.onlyPath,
        loadChildren: () => import ('./user/user.module').then ((m) => m.UserModule)
      },
      {
        path: PATHS_PROFILE_PAGES.onlyPath,
        loadChildren: () => import ('./profile/profile.module').then ((m) => m.ProfileModule)
      },
     
    ]
  },
];


@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
